import api from './api';

const orderService = {
    createOrder: async (orderData) => {
        const response = await api.post('/api/commandes/', orderData);
        return response.data;
    },

    getOrders: async () => {
        const response = await api.get('/api/commandes/');
        return response.data;
    },
    // Admin-specific fetch all orders
    getAllOrders: async () => {
        const response = await api.get('/api/admin/commandes/');
        return response.data;
    },

    updateOrderStatus: async (orderId, status) => {
        const response = await api.patch(`/api/admin/commandes/${orderId}/`, { status });
        return response.data;
    },

    updateOrder: async (orderId, orderData) => {
        const response = await api.patch(`/api/admin/commandes/${orderId}/`, orderData);
        return response.data;
    },

    deleteOrder: async (orderId) => {
        const response = await api.delete(`/api/admin/commandes/${orderId}/`);
        return response.data;
    }
};

export default orderService;
